import { z } from 'zod';
import { carouselPayloadSchema, carouselRenderDtoSchema } from './carousel.js';
import { chargedViaSchema } from './credits.js';

/** Wire DTO (snake_case) — what the API returns. */
export const generationDtoSchema = z.object({
  id: z.number().int().positive(),
  session_id: z.number().int().positive(),
  content: z.string(),
  model: z.string().nullable(),
  tokens_used: z.number().int().nullable(),
  is_free_rewrite: z.boolean(),
  user_feedback: z.string().nullable(),
  created_at: z.string().datetime(),
  // Structured slides for carousel generations; null for reels.
  payload: carouselPayloadSchema.nullable(),
});
export type GenerationDto = z.infer<typeof generationDtoSchema>;

/** Response of POST /sessions/:id/generate */
export const sessionGenerateResponseSchema = z.object({
  generation: generationDtoSchema,
  balance: z.number().int().nonnegative(),
  session_status: z.literal('completed'),
  // PNG slides for the session's current style; null for reels or if rendering failed.
  render: carouselRenderDtoSchema.nullable(),
  // How the generation was paid: credits or turbo.
  charged_via: chargedViaSchema,
});
export type SessionGenerateResponse = z.infer<typeof sessionGenerateResponseSchema>;
